"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coverageTypes = __importStar(require("./coverageTypes"));
exports.maxPaymentQuantities = __importStar(require("./maxPaymentQuantities"));
exports.products = __importStar(require("./products"));
exports.quotationStatus = __importStar(require("./quotationStatus"));
exports.specialCoverages = __importStar(require("./specialCoverages"));
exports.dateFormat = __importStar(require("./dateFormat"));
exports.identificationTypes = __importStar(require("./identificationTypes"));
exports.genders = __importStar(require("./genders"));
exports.paymentCodes = __importStar(require("./paymentCodes"));
var emailRegex_1 = require("./emailRegex");
Object.defineProperty(exports, "emailRegex", { enumerable: true, get: function () { return emailRegex_1.default; } });
exports.customerTypes = __importStar(require("./customerTypes"));
exports.discountTypes = __importStar(require("./discounts"));
exports.paymentQuantityTypes = __importStar(require("./paymentQuantityTypes"));
exports.projectWhereItComesFrom = __importStar(require("./projectWhereItComesFrom"));
//# sourceMappingURL=index.js.map